import { DocumentUploadBody } from './DocumentUpload.Body';
import { DocumentUploadFooter } from './DocumentUpload.Footer';

/** Compound component for the "Documents" step. */
export const DocumentUpload = {
  Body: DocumentUploadBody,
  Footer: DocumentUploadFooter,
};
